import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Typography,
  Collapse,
  CardContent,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import cx from "classnames";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../../content-request/styles";
import { type } from "os";
import { bindActionCreators } from "redux";
import CustomInfoIcon from "../../common/CustomInfoIcon";
interface SidePanelCardProps extends WithStyles<typeof userStyles> {
  filter: any;
  onChange: Function;
  title: string;
  extraRender: any;
  showOnlyCustom: boolean;
  valueKey: string;
  labelKey: string;
  name: string;
  allowScroll: boolean;
  showSubFilters: boolean;
}
interface SidePanelCardState {
  expandedFilter: boolean;
  filter: any;
}

class SidePanelCard extends Component<SidePanelCardProps, SidePanelCardState> {
  constructor(props: SidePanelCardProps) {
    super(props);
    this.state = {
      expandedFilter: true,
      filter: props.filter,
    };
  }
  // componentDidUpdate(prevProps:SidePanelCardProps) {
  //   if(prevProps.filterItems!==this.props.filterItems){
  //     console.log("innreUpdate",this.props.filterItems);
  //        this.setState({filterItems:{...this.props.filterItems}});
  //   }
  // }

  filterExpandClick = (value: any) => {
    this.setState({
      expandedFilter: !this.state.expandedFilter,
    });
  };

  renderSubFilter = (filterItems: any) => {
    const { classes, valueKey, labelKey, showSubFilters } = this.props;
    const { values, standardValues } = filterItems;
    
    return (
      <Grid
        className={this.props.title === "Goals" ? classes.manageSearchList : ""}
      >
        {this.props.title === "Goals" &&
        standardValues &&
        showSubFilters &&
        standardValues.length < 4 ? 
          (standardValues.length > 0 && standardValues.length < 4 ? ( <Grid title={""}></Grid>) :(
          <Grid title={"No Goal(s) Found"}>
            <span className={classes.noGoalFound}>No Goal(s) Found</span>
          </Grid>
        )) : (
          showSubFilters &&
          standardValues.map((option: any, index: number) => (
            <Grid title={option[labelKey]}>
              <FormControlLabel
                control={
                  <Checkbox
                    classes={{
                      root: classes.checkBoxElement,
                      checked: classes.checkedCheckbox,
                      colorPrimary: classes.primaryColor,
                    }}
                    checked={values.includes(option[valueKey]) ? true : false}
                    color="primary"
                    value={option[valueKey]}
                    onChange={() => this.props.onChange(option[valueKey])}
                    key={index}
                  />
                }
                label={option[labelKey]}
                classes={{
                  label: [classes.checkboxLabel, classes.truncate].join(" "),
                  root: classes.formControlLabel,
                }}
              />
            </Grid>
          ))
        )}
      </Grid>
    );
  };

  render() {
    const { classes, title, filter, name, allowScroll, showSubFilters } = this.props;
    const { expandedFilter } = this.state;

    return (
      <Card classes={{ root: classes.customCard }} elevation={0}>
        <CardHeader
          action={
            <>
              <div className={classes.marginTop12}>
                <IconButton
                  className={cx(classes.expand, {
                    [classes.expandOpen]: !expandedFilter,
                  })}
                  onClick={(e) => this.filterExpandClick(e.target)}
                  aria-expanded={true}
                  aria-label="show more"
                >
                  <ExpandMoreIcon fontSize="small" height="1.5em" />
                </IconButton>
              </div>
            </>
          }
          title={
            <Typography component="h6" variant="body1">
              {title}
              {/* <CustomInfoIcon
                  infoDialogContentType="SidePanelCard"
                  isInfoIcon={true}
                  isRightArrow={false}
                  isCenterArrow={true}
                  knowMoreAbout={false}
                  dialogTitle={title}
                  imageURL="/assets/svg/infoIcon/myLibrary/grace-award.svg"
                  dialogPara="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
                  details="Click to know more"
                  toolTipDirection="top"
                /> */}
            </Typography>
          }
          className={classes.cardHeader}
        />
        <Collapse in={expandedFilter} timeout="auto" unmountOnExit>
          <CardContent className={`${ showSubFilters ? classes.scrollBarX : classes.scrollBarXWithoutContent}`}>
            {/* <PerfectScrollbar> */}
            {allowScroll ? (
              <PerfectScrollbar>
                <Grid>
                  {this.props.extraRender && (
                    <>
                      {this.props.extraRender()}
                      <span className={classes.dividerSpacing}>
                        <Divider />
                      </span>
                    </>
                  )}
                  {/* {this.props.extraRender && <Divider />} */}
                  {!this.props.showOnlyCustom &&
                    this.renderSubFilter(filter[name])}
                </Grid>
              </PerfectScrollbar>
            ) : (
              <Grid>
                {this.props.extraRender && (
                  <>
                    {this.props.extraRender()}
                    <span className={classes.dividerSpacing}>
                      <Divider />
                    </span>
                  </>
                )}
                {/* {this.props.extraRender && <Divider />} */}
                {!this.props.showOnlyCustom &&
                  this.renderSubFilter(filter[name])}
              </Grid>
            )
            }
            {/* </PerfectScrollbar> */}
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(SidePanelCard));
